import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import {i18n} from '~/plugins'
import App from '~/components/App'
import Notifications from 'vue-notification'
import ToggleButton from 'vue-js-toggle-button'
import '~/components'

Vue.config.productionTip = false;

Vue.use(Notifications);
Vue.use(ToggleButton);

new Vue({
    i18n,
    store,
    router,
    ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js